import { useTranslation } from "react-i18next";
import { Client } from "../../models/Client";
import { FrequencyFormModel } from "../../models/FollowUp";
import { Lead } from "../../models/Lead";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../state/store";
import { useEffect, useMemo, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { Toast } from "../../components/Toast";
import { Modal } from "../../components/Modal";
import { Form } from "../../components/form/Form";
import { toast, ToastContainer } from "react-toastify";
import { LoadingMask } from "../../components/LoadingMask";
import { SmallModal } from "../../components/SmallModal";
import { ReactiveFormSelect } from "../../components/form/ReactiveFormSelect";
import { assingFollowUpMessage } from "../../state/automations/action";

interface Props {
    info: {
        show: boolean;
        client?: Client;
        lead?: Lead;
    };
    onClose: () => void;
}

export const AssignFrequencyAutomationModal: React.FC<Props> = ({
    info,
    onClose
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();

    const followUpMessages = useSelector((state: RootState) => state.automations.followUpMessages)
    const isAssignLoading = useSelector((state: RootState) => state.automations.isLoadingFollowUpMessages);
    const assignFollowUpError = useSelector((state: any) => state.automations.errorFollowUpMessages);
    const [showFollowUpError, setShowFollowUpError] = useState(false);

    useEffect(() => {
        if (showFollowUpError) {
          Toast(t(assignFollowUpError?.reason ?? "SOMETHING_WENT_WRONG"), t(assignFollowUpError?.cause_info));
          setShowFollowUpError(false);
        }
    }, [showFollowUpError, assignFollowUpError, t]);

    const methods = useForm<any>({
            defaultValues: {}
    })
    const { handleSubmit, control, reset } = methods;

    const onSubmit = (data: any) => {
        if(data.follow_up) {
            const selectedFollowUp = followUpMessages.find((e: any) => e.id === +data.follow_up);
            if(selectedFollowUp) {
                if(info.client !== undefined) {
                    onAssignClientFrequencyAutomation(selectedFollowUp, info.client);
                } else if(info.lead !== undefined) {
                    onAssignLeadFrequencyAutomation(selectedFollowUp, info.lead);
                }
            }
        } else {
            toast(t("PLEASE_SELECT_A_FREQUENCY_AUTOMATION"));
        }
    }

    const onAssignClientFrequencyAutomation = (followUp: FrequencyFormModel, client: Client) => {
        dispatch(assingFollowUpMessage({followUpId: followUp.id!, clientId: client.id})).then((e) => {
          if (e.type === "followUp/assingFollowUpMessage/rejected") {
            setShowFollowUpError(true);
          } else {
            toast(t("SUCCESSFULLY_ASSING_FOLLOW_UP"));
            closeModal();
          }
        });
    };

    const onAssignLeadFrequencyAutomation = (followUp: FrequencyFormModel, lead: Lead) => {
        dispatch(assingFollowUpMessage({followUpId: followUp.id!, leadId: lead.id})).then((e) => {
          if (e.type === "followUp/assingFollowUpMessage/rejected") {
            setShowFollowUpError(true);
          } else {
            toast(t("SUCCESSFULLY_ASSING_FOLLOW_UP"));
            closeModal();
          }
        });
    };
    
    const closeModal = () => {
        reset({});
        onClose();
    };

    const getFrequencyAutomations = useMemo(() => {
        return followUpMessages.map((a: FrequencyFormModel) => {
          return {
            label: `${a.description}`,
            value: `${a.id}`,
            key: a.id,
          };
        });
    }, [followUpMessages]);

    return (<>
        <SmallModal
            label={t('ASSIGN_FREQUENCY_AUTOMATION')}
            isOpen={info.show}
            onClose={closeModal}
            onSave={handleSubmit(onSubmit)}
        >
            <Form handleOnSubmit={handleSubmit(onSubmit)}>
                <div className={"w-full px-3"}>
                    <ReactiveFormSelect
                        width="md:w-1/1"
                        name={`follow_up`}
                        label={t("FREQUENCY_AUTOMATION")}
                        options={getFrequencyAutomations}
                        control={control}
                    />
                    <label className="text-gray-600 text-xs mb-5">
                        {t("ASSIGN_FREQUENCY_AUTOMATION_MESSAGE")}
                    </label>
                </div>
            </Form>
        </SmallModal>
        {isAssignLoading && <LoadingMask />}
        <ToastContainer progressStyle={{ background: "#D4AF37" }} />
    </>)
}